import {
  INSTALLERS_START,
  INSTALLERS_ERROR,
  INSTALLERS_SUCCESS,
  INSTALLER_ADD_START,
  INSTALLER_ADD_ERROR,
  INSTALLER_ADD_SUCCESS,
  INSTALLER_UPDATE_START,
  INSTALLER_UPDATE_ERROR,
  INSTALLER_UPDATE_SUCCESS,
  INSTALLER_DISABLE_START,
  INSTALLER_DISABLE_ERROR,
  INSTALLER_DISABLE_SUCCESS,
  INSTALLER_COMPANY_START,
  INSTALLER_COMPANY_ERROR,
  INSTALLER_COMPANY_SUCCESS,
  CHANGE_PASSWORD_START,
  CHANGE_PASSWORD_ERROR,
  CHANGE_PASSWORD_SUCCESS
} from '../constants/Constants.js';
import api from '../api';
import messages from '../messages';

let strings = messages.getLocalizedStrings();

function getErrorMsg(msgList, path) {
  if (~path.indexOf('.')) {
    let location = path.split('.');
    return getErrorMsg(msgList[location[0]], location.slice(1));
  }
  return msgList[path];
}

function getErrorMessage(path) {
  if (~path.indexOf('.')) {
    let location = path.split('.');
    return getErrorMsg(strings.error[location[0]], location.slice(1));
  }
  return strings.error[path];
}

export function loadInstallers(installerCompany) {
  return dispatch => {
    dispatch({
      type: INSTALLERS_START
    });

    api.loadInstallers(installerCompany, function(err, res) {
      if (err) {
        //TODO
        if (err.status === 403) {
          dispatch({
            type: INSTALLERS_ERROR,
            text: getErrorMessage('installer.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: INSTALLERS_ERROR,
            text: getErrorMessage('installer.load-fail'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        let installers = [];
        if (res.body) {
          installers = res.body;
        }
        dispatch({
          type: INSTALLERS_SUCCESS,
          installers: installers
        });
      }
    });
  };
}

export function addInstaller(installer, callback) {
  return dispatch => {
    dispatch({
      type: INSTALLER_ADD_START
    });

    api.addInstaller(installer, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: INSTALLER_ADD_ERROR,
            text: getErrorMessage(err.response.text),
            level: 'error',
            timeout: 5000
          });
        }
        if (err.status === 409) {
          dispatch({
            type: INSTALLER_ADD_ERROR,
            text: getErrorMessage(err.response.text),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: INSTALLER_ADD_ERROR,
            text: getErrorMessage(err.response.text),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: INSTALLER_ADD_SUCCESS
        });
      }

      callback(err);
    });
  };
}

export function updateInstaller(installer, callback) {
  return dispatch => {
    dispatch({
      type: INSTALLER_UPDATE_START
    });

    api.updateInstaller(installer, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: INSTALLER_UPDATE_ERROR,
            text: getErrorMessage('installer.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else if (err.status === 409) {
          dispatch({
            type: INSTALLER_UPDATE_ERROR,
            text: getErrorMessage('installer.duplicate'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: INSTALLER_UPDATE_ERROR,
            text: getErrorMessage('installer.update-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: INSTALLER_UPDATE_SUCCESS
        });
      }

      callback(err);
    });
  };
}

export function disableInstaller(installer, callback) {
  return dispatch => {
    dispatch({
      type: INSTALLER_DISABLE_START
    });

    api.disableInstaller(installer, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: INSTALLER_DISABLE_ERROR,
            text: getErrorMessage('installer.no-access'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: INSTALLER_DISABLE_ERROR,
            text: getErrorMessage('installer.removed-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: INSTALLER_DISABLE_SUCCESS
        });
      }

      callback(err);
    });
  };
}

export function loadInstallerCompany(id) {
  return dispatch => {
    dispatch({
      type: INSTALLER_COMPANY_START
    });

    api.loadInstallerCompany(id, function(err, res) {
      if (err) {
        //TODO
        if (err.status === 403) {
          dispatch({
            type: INSTALLER_COMPANY_ERROR,
            text: 'U heeft geen toegang tot de installer companies',
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: INSTALLER_COMPANY_ERROR,
            text: 'De installer companies kunnen niet worden geladen: ' + err,
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        let installerCompany = {};
        if (res.body) {
          installerCompany = res.body;
        }
        dispatch({
          type: INSTALLER_COMPANY_SUCCESS,
          installerCompany: installerCompany
        });
      }
    });
  };
}

export function changePassword(currentPassword, newPassword, callback) {
  return dispatch => {
    dispatch({
      type: CHANGE_PASSWORD_START
    });

    api.changePassword(currentPassword, newPassword, function(err, res) {
      if (err) {
        if (res.text && getErrorMessage(res.text)) {
          dispatch({
            type: CHANGE_PASSWORD_ERROR,
            text: getErrorMessage(res.text),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: CHANGE_PASSWORD_ERROR,
            text: getErrorMessage('password.change-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: CHANGE_PASSWORD_SUCCESS,
          text: getErrorMessage('password.password-changed'),
          level: 'info',
          timeout: 5000
        });
      }

      callback(err, res);
    });
  };
}

/***
 * Change password for a specific User
 */
export function changePasswordUser(user, newPassword, callback) {
  return dispatch => {
    dispatch({
      type: CHANGE_PASSWORD_START
    });

    api.changePasswordUser(user, newPassword, function(err, res) {
      if (err) {
        if (res.text && getErrorMessage(res.text)) {
          dispatch({
            type: CHANGE_PASSWORD_ERROR,
            text: getErrorMessage(res.text),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: CHANGE_PASSWORD_ERROR,
            text: getErrorMessage('password.change-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: CHANGE_PASSWORD_SUCCESS,
          text: getErrorMessage('password.password-changed'),
          level: 'info',
          timeout: 5000
        });
      }

      callback(err, res);
    });
  };
}

export function onEditInstallerCompany(installerCompany) {
  return dispatch => {
    dispatch({
      type: 'INSTALLER_COMPANY_EDIT',
      installerCompany: installerCompany
    });
  };
}



// WEBPACK FOOTER //
// /src/actioncreators/InstallerCompanyActions.js